import React from 'react'
import {Col, Row, Container} from 'reactstrap'
import {FaStar} from 'react-icons/fa'
import styled from 'styled-components'

let Background = styled.div`
  background: linear-gradient(to bottom, #f9fbfd 0, #fff 100%);
`

let Testimonial = ({stars = 5, content}) => (
  <Col md={4}>
    {[...Array(stars)].map(star => (
      <FaStar className="mr-1" color="#ec9a3c"/>
    ))}
    <p className="mt-3">{content}</p>
    <h6 className="font-weight-bold mb-0">Oreo</h6>
    <small className="text-secondary">Goldendoodle</small>
  </Col>
)

export default () => (
  <Background>
    <Container className="py-5">
      <h2 className="text-center">Doggo Testimonials</h2>
      <Row className="d-flex justify-content-center">
        <Col md="7">
          <p className="text-center text-secondary">
            Lorem <u>Ipsum</u> and <u>Ipsum</u>
          </p>
        </Col>
      </Row>
      <Row className="mt-4">
        <Testimonial content="Wow so amazing to find out stats about my breed"/>
        <Testimonial content="Woof woof woof!"/>
        <Testimonial content="Quickly design and customize responsive mobile-first sites with Bootstrap, the world’s most popular front-end open source toolkit."/>
      </Row>
    </Container>
  </Background>
)
